import type { Listing } from '@thevillages/schemas';

import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { Component, inject, input, type OnChanges, PLATFORM_ID } from '@angular/core';

import { Environment } from '../../../environments/environment';
import { ContactFab } from '../../components/contact-fab/contact-fab';
import { ListingDetails } from '../../components/listing-details/listing-details';
import { Modals } from '../../components/modals/modals';
import { ListingsService } from '../../services/listings/listings';
import { SeoService } from '../../services/seo/seo';

@Component({
  imports: [ListingDetails, ContactFab, Modals],
  selector: 'app-listing',
  styleUrl: './listing.page.css',
  templateUrl: './listing.page.html',
})
export class ListingPage implements OnChanges {
  private readonly _listingsService = inject(ListingsService);
  private readonly _location = inject(Location);
  private readonly _platformId = inject(PLATFORM_ID);
  private readonly _seoService = inject(SeoService);

  // Resolved listing data from the route.
  public readonly listing = input<Listing>();

  protected navigateToHomefinder(): void {
    this._location.go('/');

    window.location.reload();
  }

  public ngOnChanges(): void {
    if (isPlatformServer(this._platformId)) {
      this._seoService.update(this.listing());

      this._seoService.dataLayerPush('property_view', {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        page_location: `${Environment.hostUrl}/${this.listing()?.id}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        page_title: `${this.listing()?.address.streetAddress} | ${this.listing()?.model?.title} | ${Environment.community === 'villages' ? 'The Villages, FL' : 'Middleton, FL'}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        page_type: 'property_detail',
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        property_baths: this.listing()?.baths?.value,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        property_beds: this.listing()?.beds,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        property_id: this.listing()?.id,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- The data layer expects snake_case keys.
        property_price: this.listing()?.price,
        // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unnecessary-condition -- The data layer expects snake_case keys.
        property_sqft: this.listing()?.squareFeet?.total,
      });
    }

    if (isPlatformBrowser(this._platformId)) {
      this._listingsService.selectedListing.set(this.listing());
    }
  }
}
